import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  blogs: [],
};

const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    addBlog: (state, action) => {
      state.blogs.push({ id: Date.now(), ...action.payload });
    },
    setBlogs: (state, action) => {
      state.blogs = action.payload;
    },
    
  },
});

export const { addBlog, setBlogs } = blogSlice.actions;
export default blogSlice.reducer;
